// A session opened with an app reviewer's review link (M56, D203) carries
// the link's id as `rvw` in its access token. Such a demo account has no
// passkey, so "Delete my account" skips the passkey check (D204); the
// server allows that only for review sessions. Reading the claim here
// doesn't verify anything; it only picks which screen to show.
export function isReviewSession(accessToken: string | null): boolean {
  if (!accessToken) return false;
  const payload = accessToken.split('.')[1];
  if (!payload) return false;
  try {
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const claims = JSON.parse(json) as { rvw?: unknown };
    return typeof claims.rvw === 'string' && claims.rvw.length > 0;
  } catch {
    return false;
  }
}

/** What "Delete my account" sends instead of a passkey check. */
export const REVIEW_VERIFICATION = { review: true } as const;
